const CHAIN_SWITCHED = '/chain-switched';
const SETTINGS = '/app/settings';
const SETTINGS_CONNECTIVITY = '/app/settings/connectivity';
const SETTINGS_CONTRACTS = '/app/settings/contracts';
const ISSUE = '/app/issue';
const REDEEM = '/app/redeem';
const CANCEL = '/app/cancel';
const VERIFY = '/app/verify';
const VERIFY_EVENT = '/app/verify/event';
const VERIFY_ASSET = '/app/verify/asset';
const DEFAULT = ISSUE;

const PATHS = {
  DEFAULT,
  CHAIN_SWITCHED,
  SETTINGS,
  SETTINGS_CONNECTIVITY,
  SETTINGS_CONTRACTS,
  ISSUE,
  REDEEM,
  CANCEL,
  VERIFY,
  VERIFY_EVENT,
  VERIFY_ASSET,
};

export default PATHS;
